import { CHANGE_MOBILE_MENU } from './types';

/**
 * Zmenime mobilne menu.
 *
 * @var string
 */
export const changeMobileMenu = type => ({ type: CHANGE_MOBILE_MENU, payload: type });
